import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { EmailList } from 'src/app/modules/user-profile/models/contact-oeds-person.model';
import { TokenResponse } from 'src/app/modules/user-profile/models/contact-token.model';
import { ContactDataService } from 'src/app/modules/user-profile/services/contact-data-service';
import { ContactVerificationService } from 'src/app/modules/user-profile/services/contact-verification-service';
import { ContactMappingService } from 'src/app/modules/user-profile/services/contact-mapping-service';
import { environment } from 'src/environments/environment';
import { CompareValidatorDirective } from '../directives/compare-validator-directive';

@Component({
    selector: 'app-contact-verification-emails',
    templateUrl: './contact-verification-emails.component.html',
    styleUrls: ['./contact-verification-emails.component.css'],
    imports: [FormsModule, ReactiveFormsModule, CompareValidatorDirective]
})
export class ContactVerificationEmailsComponent implements OnInit {
  private router = inject(Router);
  private cDataService = inject(ContactDataService);
  cService = inject(ContactVerificationService);
  cMappingService = inject(ContactMappingService);
  private spinner = inject(NgxSpinnerService);

  emailForm: FormGroup;
  isbtnclicked = false;
  isNewEmailExist = false;
  newEmail = "";
  reenterEmail = "";
  reenterExEmail = "";
  showHomeOhId = true;
  showHomeOtherId = false;
  showHomeDontUse = false;
  showHomeAddNew = false;
  tokenItem: TokenResponse;
  homeEmail: EmailList;
  routeFlag = false;
  existingEmail = "";
  isFormvalid = false;
  personEmail = "";
  emailType = "Home";
  oedsEmailTypeKey = this.cMappingService.getOedsEmailTypeKey(this.emailType);

  ngOnInit(): void {
    this.emailForm = new FormGroup({
      newEmail: new FormControl("", Validators.compose([Validators.required])),
      newEmail2: new FormControl("", Validators.compose([Validators.required]))
    });
    this.tokenItem = this.cService.tokenDtls;
    this.homeEmail = this.cService.filterEmailByType(this.oedsEmailTypeKey, this.cService.oedsPersonCopy.emailList)[0];
    if (this.homeEmail !== undefined) {
      if (this.cService.existingHomeEmail === "" && this.homeEmail.oedsEmailKey !== 0) {
        this.cService.existingHomeEmail = this.homeEmail.email;
      }
      this.existingEmail = this.cService.existingHomeEmail;
      if (this.cService.homeEmailOption === 'home-1')
        this.toggleshowHomeOhId();
    }
    switch (this.cService.homeEmailOption) {
      case 'home-2': {
        this.toggleshowHomeOtherId();
        this.reenterExEmail = this.cService.reEnterExHomeEmail;
        break;
      }
      case 'home-3': {
        this.toggleshowHomeDontUse();
        break;
      }
      case 'home-4': {
        this.showHomeAddNew = true;
        this.isNewEmailExist = true;
        this.newEmail = this.homeEmail.email;
        this.reenterEmail = this.homeEmail.email;
        this.personEmail = this.newEmail;
        break;
      }
      default: {
        this.toggleshowHomeOhId();
        break;
      }
    }
    this.getIshomeEmailRequired();
  }

  getIshomeEmailRequired() {
    if (this.cService.isHomeEmailRequired === null) {
      this.spinner.show();
      //API call to get Is Home Email Required or NOT
      this.cDataService.gethomeEmailRequired().subscribe({
        next: (response: string) => {
          if (response === "Y" || response === "y")
            this.cService.isHomeEmailRequired = true;
          else
            this.cService.isHomeEmailRequired = false;
          this.spinner.hide();
        },
        error: (error) => {
          this.spinner.hide();
          this.cService.contactVerificationFailed = true;
        }
      });
    }
  }
  getIsFormvalid() {
    if (this.cService.homeEmailOption === 'home-1' ||
      this.cService.homeEmailOption === 'home-2' && this.existingEmail === this.reenterExEmail ||
      this.cService.homeEmailOption === 'home-3' && this.cService.isHomeEmailRequired === false ||
      this.cService.homeEmailOption === 'home-4' && this.emailForm.valid && this.isbtnclicked ||
      this.cService.homeEmailOption === 'home-4' && this.emailForm.valid && this.isNewEmailExist) {
      return false;
    }
    else {
      return true;
    }
  }
  toggleshowHomeOhId() {
    this.cService.homeEmailOption = 'home-1';
    this.showHomeOhId = true;
    this.showHomeOtherId = false;
    this.showHomeDontUse = false;
    this.showHomeAddNew = false;
    this.personEmail = this.tokenItem.ohidEmail;
  }

  toggleshowHomeOtherId() {
    this.cService.homeEmailOption = 'home-2';
    this.showHomeOtherId = true;
    this.showHomeOhId = false;
    this.showHomeDontUse = false;
    this.showHomeAddNew = false;
    this.personEmail = this.existingEmail;
  }

  toggleshowHomeDontUse() {
    this.cService.homeEmailOption = 'home-3';
    this.showHomeDontUse = true;
    this.showHomeOhId = false;
    this.showHomeOtherId = false;
    this.showHomeAddNew = false;
    this.cService.deleteEmailByType(this.oedsEmailTypeKey)
  }

  toggleshowHomeAddNew() {
    this.cService.homeEmailOption = 'home-4';
    this.showHomeAddNew = true;
    this.showHomeDontUse = false;
    this.showHomeOhId = false;
    this.showHomeOtherId = false;
  }

  addNewHomeEmail() {
    this.isbtnclicked = true;
    this.showHomeAddNew = false;
    this.personEmail = this.newEmail;
  }
  cancleNewHomemeail() {
    this.newEmail = "";
    this.showHomeAddNew = false;
    this.toggleshowHomeOhId();
  }
  updateStepCount(isnext) {
    this.cService.reEnterExHomeEmail = this.reenterExEmail;
    if (isnext) {
      if (this.cService.homeEmailOption !== 'home-3') {
        this.cService.insertUpdateEmail(this.personEmail, this.oedsEmailTypeKey, this.cService.isUserOrgMappingExist ? false : true, true);
        //If more than one personal email delete all email except the Inserted/Updated one 
        let personalEmails = this.cService.oedsPersonCopy.emailList.filter(x => x.actionType === "" && x.oedsEmailType === this.oedsEmailTypeKey);
        if (personalEmails.length !== 0) {
          for (const item of personalEmails) {
            item.actionType = "Deleted"
          }
        }
      }
      if (environment.debug) console.log("Step 1 OEDS Person Object:" + JSON.stringify(this.cService.oedsPersonCopy));
      if (this.cService.isUserOrgMappingExist || this.cService.hasOfficeEmail) {
        this.cService.setStep('Office Email');
        this.cService.stepCount++;
      }
      else {
        this.cService.setStep('Address');
        this.cService.stepCount++;
      }
    }
    else {
      this.cService.isBackNav = true;
      this.cService.setStep('Introduction');
      this.cService.stepCount--;
    }
  }
}
